import axiosInstance from "@/lib/axiosInstance";
import { notificationsEndpoints } from "./notifications.endpoints";

export const setNotificationRead = async (notificationId: string, isRead: boolean) => {
  const response = await axiosInstance.put(notificationsEndpoints.update(notificationId), {
    isRead,
  });
  return response.data;
};
